import React from "react";
import "./spreadDiagramsClean.css";

const CARD_BACK_URL = `${process.env.PUBLIC_URL}/assets/tarot/tarot-tausta-kortti.png`;

function Card({ n, style = {} }) {
  return (
    <div
      className="am-card"
      style={{
        ...style,
        backgroundImage: `url(${CARD_BACK_URL})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="am-badge">{n}</div>
    </div>
  );
}

function Canvas({ w, h, diagramIndex, children }) {
  return (
    <div className={`am-canvas-wrap am-canvas-wrap-${diagramIndex}`} data-diagram-index={diagramIndex}>
      <div className="am-canvas" style={{ width: w, height: h }}>
        {children}
      </div>
    </div>
  );
}

/** Yksi kaavio indeksillä: 0 = yksi kortti, 1 = kolme, 2 = neljä, 3 = viisi, 4 = Celtic Cross. */
const DIAGRAM_CONFIGS = [
  { title: "Yksi kortti", w: 420, h: 220, cards: [{ n: 1, left: 164, top: 35 }] },
  {
    title: "Kolme korttia",
    w: 520,
    h: 220,
    cards: [
      { n: 1, left: 90, top: 35 },
      { n: 2, left: 214, top: 35 },
      { n: 3, left: 338, top: 35 },
    ],
  },
  {
    title: "Neljä korttia",
    w: 520,
    h: 260,
    cards: [
      { n: 1, left: 150, top: 30 },
      { n: 2, left: 278, top: 30 },
      { n: 3, left: 150, top: 110 },
      { n: 4, left: 278, top: 110 },
    ],
  },
  {
    title: "Viisi korttia",
    w: 520,
    h: 500,
    cards: [
      { n: 1, left: 214, top: 130 },
      { n: 2, left: 104, top: 130 },
      { n: 3, left: 324, top: 130 },
      { n: 4, left: 214, top: -38 },
      { n: 5, left: 214, top: 298 },
    ],
  },
  {
    title: "Celtic Cross",
    w: 800,
    h: 430,
    cards: [
      { n: 1, left: 170, top: 95, transform: "rotate(-4deg)" },
      { n: 2, left: 170, top: 95, transform: "rotate(90deg)" },
      { n: 3, left: 170, top: 285 },
      { n: 4, left: 12, top: 95 },
      { n: 5, left: 170, top: -72 },
      { n: 6, left: 318, top: 95 },
      { n: 7, left: 540, top: 10 },
      { n: 8, left: 540, top: 95 },
      { n: 9, left: 540, top: 180 },
      { n: 10, left: 540, top: 265 },
    ],
  },
];

export function SpreadDiagramByIndex({ index, showTitle = false }) {
  const config = DIAGRAM_CONFIGS[index];
  if (!config) return null;
  return (
    <div className="am-spread am-spread-single">
      {showTitle && <div className="am-title">{config.title}</div>}
      <Canvas w={config.w} h={config.h} diagramIndex={index}>
        {config.cards.map((c, i) => (
          <Card
            key={i}
            n={c.n}
            style={{
              left: c.left,
              top: c.top,
              ...(c.transform && { transform: c.transform }),
            }}
          />
        ))}
      </Canvas>
    </div>
  );
}

export default function SpreadDiagramsClean() {
  return (
    <div className="am-spreads">
      {DIAGRAM_CONFIGS.map((config, index) => (
        <SpreadDiagramByIndex key={index} index={index} showTitle />
      ))}
    </div>
  );
}
